import { BenefitRiderModel } from 'src/app/models/select-plans/product-rider.model';
import { FormulaType } from 'src/app/models/type/formla.type';

export class ProductModel {
  msProductId?: number;
  planGroupId: any;
  planGroupCode: string;
  planGroupName: string;
  productId?: any;
  productCode?: string;
  productLevelCode?: string;
  formulaType: FormulaType | string;
  product: Array<ProductRiderModel>;
  benefit?: Array<BenefitRiderModel>;
  cowrie?: number;
  ciCowrie?: number;
  productGroupCode?: string;
  insuredPeriod?: number;
  paymentPeriod?: any;
  _isSelected?: boolean;
  _productTabActive?: any;
  _coverage?: number;
  productPackageId?: number;
  keywordList?: [];
  paymentSingle?: boolean;
  planGroupNameEN: string;
  planGroupNameTH: string;
  productCodeDisable: string;
  disableConvertType?: boolean;
  disableConvertList?:[];
  is_product_choice?:boolean;


  constructor(msProductId?: number, planGroupId?: any, planGroupCode?: string, planGroupName?: string, planGroupNameEN?: string, planGroupNameTH?: string, formulaType?: FormulaType,
              product?: Array<ProductRiderModel>, benefit?: Array<BenefitRiderModel>, cowrie?: number, ciCowrie?: number,
              isSelected?: boolean, productTabActive?: any, coverage?: number, keywordList?: [], productGroupCode?: string,productCodeDisable?: string,
              disableConvertList?:[],disableConvertType?: boolean ,is_product_choice?:boolean) {
    this.msProductId = msProductId;
    this.planGroupId = planGroupId;
    this.planGroupCode = planGroupCode;
    this.planGroupName = planGroupName;
    this.planGroupNameTH = planGroupNameTH;
    this.planGroupNameEN = planGroupNameEN;
    this.formulaType = formulaType;
    this.product = product ? product : new Array<ProductRiderModel>();
    this.benefit = benefit;
    this.cowrie = cowrie;
    this.ciCowrie = ciCowrie;
    this._isSelected = isSelected;
    this._productTabActive = productTabActive;
    this._coverage = coverage;
    this.keywordList = keywordList;
    this.productGroupCode = productGroupCode;
    this.productCodeDisable = productCodeDisable;
    this.disableConvertType = disableConvertType;
    this.disableConvertList = disableConvertList;
    this.is_product_choice = is_product_choice;
  }
}

export class  ProductRiderModel {
  productId?: any;
  productCode?: string;
  productLevelCode?: string;
  productName?: string;
  sumAssured?: number; // case formulaType: SA, NONE
  premium?: number; // case formulaType = FIX only
}
